import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { CustomerDemoData } from '../../../data';
import { useInit } from '../../Contexts/InitProvider';
import LibModal from '../../features/LibModal/LibModal';
import { useTemplate } from '../../features/template/TemplateProvider';
import { handleGetAllCustomer } from './CustomerOperation';
import CustomerCurrencyChangeModal from './Modals/CustomerCurrencyChangeModal';
import CustomerRoleChangeModal from './Modals/CustomerRoleChangeModal';
import CustomerStatusChangeModal from './Modals/CustomerStatusChangeModal';
import EditCustomerModal from './Modals/EditCustomerModal';

const CustomerContext = createContext();
export const useCustomer = () => useContext(CustomerContext);

function CustomerProvider({ children }) {
    const { setMessage, setConfirm } = useTemplate();
    const [reloadKey, setReloadKey] = useState(0);
    const [infoReloadKey, setInfoReloadKey] = useState(0);
    const [params, setParams] = useState({});
    const { initInfo } = useInit();

    const [customerListData, setCustomerListData] = useState({
        customers: CustomerDemoData,
        pagination: {}
    });
    const [createCustomerModal, setCreateCustomerModal] = useState(false);
    const [editCustomerModal, setEditCustomerModal] = useState({
        show: false,
        data: {}
    });

    // -- Load all customer initially
    useEffect(() => {
        setCustomerListData({ customers: CustomerDemoData, pagination: {} });
        if (Object.keys(params).length > 0) {
            handleGetAllCustomer(params)
                .then(({ data }) => {
                    setCustomerListData(data);
                })
                .catch((err) => {
                    setCustomerListData({ customers: [], pagination: {} });
                    setMessage({ type: 'error', text: err.toString(0) });
                });
        }
    }, [params, setMessage, reloadKey]);

    const valueCtx = useMemo(() => {
        // --Handle Reload
        const handleReload = () => {
            setReloadKey((d) => d + 1);
        };

        // Create new customer modal show/hide handler
        const handleShowCreateModal = () => setCreateCustomerModal(true);

        // -- Edit Customer Modal
        const handleShowEditModal = (ev, data) => {
            ev?.stopPropagation();
            setEditCustomerModal({ show: true, data });
        };

        // const closeEditModal = () => setEditCustomerModal({ show: false, data: {} });
        // Change Customer Type Handler
        const handleCustomerTypeModal = (e, data) => {
            e.stopPropagation();
            setConfirm({
                showButton: false,
                text: (
                    <CustomerRoleChangeModal
                        data={data}
                        roles={initInfo?.roles}
                        setReloadKey={setReloadKey}
                        setInfoReloadKey={setInfoReloadKey}
                    />
                )
            });
        };
        // -- Change Currency Handler
        const handleChangeCurrencyModal = (e, data) => {
            e.stopPropagation();
            setConfirm({
                showButton: false,
                text: (
                    <CustomerCurrencyChangeModal
                        data={data}
                        setReloadKey={setReloadKey}
                        setInfoReloadKey={setInfoReloadKey}
                    />
                )
            });
        };

        // -- Change Customer Status Handler
        const handleCustomerStatusModal = (e, data) => {
            e.stopPropagation();
            setConfirm({
                showButton: false,
                text: (
                    <CustomerStatusChangeModal
                        data={data}
                        setReloadKey={setReloadKey}
                        setInfoReloadKey={setInfoReloadKey}
                    />
                )
            });
        };

        return {
            // -- Reload Key
            reloadKey,
            setReloadKey,
            infoReloadKey,
            setInfoReloadKey,
            // -- Params
            params,
            setParams,
            // -- customer list
            customerListData,
            setCustomerListData,
            // -- create modal
            createCustomerModal,
            setCreateCustomerModal,
            // -- Edit Customer Modal
            editCustomerModal,
            setEditCustomerModal,
            // All Handler
            handleReload,
            // -- Create Customer Modal
            handleShowCreateModal,
            // -- Edit Customer Modal
            handleShowEditModal,
            // -- Customer Type Change Modal
            handleCustomerTypeModal,
            // -- Customer Status Change Modal
            handleCustomerStatusModal,
            // -- Change Currency Modal
            handleChangeCurrencyModal
        };
    }, [
        createCustomerModal,
        customerListData,
        editCustomerModal,
        infoReloadKey,
        initInfo.roles,
        params,
        reloadKey,
        setConfirm
    ]);

    return (
        <CustomerContext.Provider value={valueCtx}>
            {children}
            {editCustomerModal.show && (
                <LibModal
                    title="Edit Customer"
                    setOpen={() => setEditCustomerModal({ show: false, data: {} })}
                    className="md:!w-[550px]"
                >
                    <EditCustomerModal
                        setReloadKey={setReloadKey}
                        setInfoReloadKey={setInfoReloadKey}
                        closeEditModal={() => setEditCustomerModal({ show: false, data: {} })}
                        data={editCustomerModal.data}
                    />
                </LibModal>
            )}
        </CustomerContext.Provider>
    );
}

export default CustomerProvider;
